import ElMenu from './menu';

/* istanbul ignore next */
ElMenu.install = function(Vue) {
  Vue.component(ElMenu.name, ElMenu);
};

export default ElMenu;
